import { ConfigProvider } from "../../configuration/ConfigProvider";

export class RecaptchaProvider {
    private static instance: RecaptchaProvider;
    private siteKey: string;
    private config = ConfigProvider.getInstance().getConfiguration();

    private constructor() {
        // @ts-ignore
        this.siteKey = this.config.recaptchaKey;
        this.loadScript(this.siteKey);
    }

    public static getInstance(): RecaptchaProvider {
        if (!RecaptchaProvider.instance) {
            RecaptchaProvider.instance = new RecaptchaProvider();
        }

        return RecaptchaProvider.instance;
    }

    public getToken(action: string): Promise<string> {
        return ((window as any).grecaptcha).execute(this.siteKey, { action: action });
    }

    private handleOnLoad(){
        console.log("[RecaptchaProvider] handle on load!")
        if (!window || !(window as any).grecaptcha) {
            console.warn('[RecaptchaProvider] Script not available!');
            return;
        }

        (window as any).grecaptcha.ready(() => {
            console.log('[RecaptchaProvider] Recaptcha ready!');
        });
    }

    private loadScript(siteKey: string){
        console.log("[RecaptchaProvider] load script for reCAPTCHA!");
        const scriptId = 'google-recaptcha-v3';
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + siteKey;
        script.onload = this.handleOnLoad;

        if (document.getElementById(scriptId)) {
            this.handleOnLoad();
            return;
        }

        const head = document.getElementsByTagName('head')[0];
        head.appendChild(script);
    }
}